export const getDisclosureFiles = state => state.upload.disclosureFiles;
export const getDisclosureFilesQueriesPaging = state => state.upload.disclosureQueries;
export const getDisclosureFilesTotal = state => state.upload.disclosureTotal;
export const getDisclosureFilesTotalPages = state => state.upload.disclosureTotalPages;

export const getPatientFiles = state => state.upload.patientFiles;
export const getPatientFilesQueriesPaging = state => state.upload.patientQueries;
export const getPatientFilesTotal = state => state.upload.patientTotal;
export const getPatientFilesTotalPages = state => state.upload.patientTotalPages;

export const getProgressingFiles = state => state.upload.progressingFiles;

export const getDeleting = state => state.upload.deleting;

export const getDisclosureYears = state => state.upload.disclosureYears;
export const getPatientYears = state => state.upload.patientYears;
